var map = {
	"./ebanisteria.avif": 9934,
	"./electricos.avif": 2527,
	"./estudiantil.avif": 4612,
	"./gas.avif": 814,
	"./griferia.avif": 5174,
	"./logocatalogo.avif": 5480,
	"./tornilleria.avif": 8153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;